import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import banner1Webm from '../static/images/banner/banner.webm';
import gartnerLogo from '../static/images/gartner_logo_white.png';

const Banner = () => (
  <StaticQuery
    query={graphql`
      query {
        imageSharp(fixed: {originalName: {eq: "banner-2.jpg"}}){
          fluid{
            ...GatsbyImageSharpFluid
          }
        }
      }
    `}
    render={data => (
      <div className="slider">
        <div className="owl-carousel owl-slider owl-theme">
          {/* item start */}
          <div className="item">
            <div className="slider-img">
              <video autoPlay loop muted playsInline>
                <source src={banner1Webm} type="video/webm" />
              </video>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  {/* slider caption start */}
                  <div className="slider-captions">
                    <h1 className="slider-title">What's the Speed of Your Defense?</h1>
                    <p className="slider-text d-none d-lg-block ">
                Rapidly anticipate, hunt, and stop attacks before they impact you get AI-Driven Managed Detection and Response.
                    </p>
                    <a href="/" className="btn btn-brand btn-rounded btn-lg">Learn More</a>
                  </div>
                  {/* slider caption close */}
                </div>
              </div>
            </div>
          </div>
          {/* item close */}
          {/* item start */}
          <div className="item">
            <div className="slider-img"><Img fluid={data.imageSharp.fluid} alt="AI-Driven Managed Detection and Response" /></div>
            <div className="container">
              <div className="row">
                <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                  {/* slider caption start */}
                  <div className="slider-captions">
                    <h1 className="slider-title">AI-Driven Managed Detection and Response</h1>
                    <p className="slider-text d-none d-lg-block">
                Designed to take down the most advanced cyber threats
                    </p>
                    <p className="d-none d-lg-block ">
                      <strong>Featuring Exclusive Research from:</strong>
&nbsp;
                      <img src={gartnerLogo} alt="Gartner_logo_White" width={135} style={{ width: 135, display: 'inline-block' }} />

                    </p>
                    <a href="/" className="btn btn-brand btn-rounded btn-lg ">Request a Free Demo</a>
                  </div>
                  {/* slider caption close */}
                </div>
              </div>
            </div>
          </div>
          {/* item close */}
        </div>
      </div>

    )}
  />
);

export default Banner;
